import type { RewardsReservationStatus, SearchRewardsReservationsParams } from '~/services/LuxLoyalty';

/** What the admin typed into the Flash Rewards reservation filters. */
export interface FlashReservationFilterInput {
  offerId: string;
  packageId: string;
  orderId: string;
  status: RewardsReservationStatus | '';
}

/**
 * Maps the hotel-specific filters onto loyalty's product-neutral search params. Loyalty's
 * catalog entry holds a hotel's offer id in `itemReference` and its package id in
 * `itemSubReference`, so this page does the translation. Values are trimmed; blank ones are left
 * out so they don't narrow the search.
 */
export function toReservationSearchFilters(
  input: FlashReservationFilterInput,
): Pick<SearchRewardsReservationsParams, 'itemReference' | 'itemSubReference' | 'orderId' | 'status'> {
  const offerId = input.offerId.trim();
  const packageId = input.packageId.trim();
  const orderId = input.orderId.trim();
  return {
    ...(offerId ? { itemReference: offerId } : {}),
    ...(packageId ? { itemSubReference: packageId } : {}),
    ...(orderId ? { orderId } : {}),
    ...(input.status ? { status: input.status } : {}),
  };
}
